import * as Sentry from "@sentry/react";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,

    integrations: [
      Sentry.browserTracingIntegration(),
    ],

    tracesSampleRate: 0.2,

    initialScope: {
      tags: { app: "webinar-frontend" },
    },

    beforeSend(event) {
      if (event.extra) {
        for (const key of Object.keys(event.extra)) {
          if (typeof event.extra[key] === "string" && /phone/i.test(key)) {
            event.extra[key] = "[REDACTED]";
          }
        }
      }
      return event;
    },
  });
}

import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
